import React, { useState, useEffect } from 'react'
import lottie from 'lottie-web'
import _uniqueId from 'lodash/uniqueId'

export default function LottieLodder({ lottieOptions, style }) {
  const [id] = useState(_uniqueId('animation-'))
  useEffect(() => {
    lottie.loadAnimation({
      loop: lottieOptions.loop,
      autoplay: lottieOptions.autoplay,
      renderer: lottieOptions.renderer,
      container: document.getElementById(`${id}`),
      animationData: lottieOptions.animationData,
    })
  }, [
    id,
    lottieOptions.animationData,
    lottieOptions.autoplay,
    lottieOptions.loop,
    lottieOptions.renderer,
  ])

  return <div id={id} style={style}></div>
}
